import { apiHeaders, apiURL } from './config';

export const loadTeamDrafts = (eventId: string) => ({
  method: 'GET',
  credentials: 'include',
  headers: apiHeaders,
  endpoint: apiURL(`/events/${eventId}/team_drafts`),
});
